export interface Paginator {
  PageSizeOpts: number[];
}

export const Paginator: Paginator = {
  PageSizeOpts: [10, 20, 50],
};
